<h1 mat-dialog-title class="dialog-title">
  <span class="title-accent"></span>
  Snooze task
</h1>
<div class="content" mat-dialog-content>
  <div class="summary">
    <div class="summary-label">Snoozing until</div>
    <div class="summary-date">{{snoozeTill | date:'fullDate'}}</div>
    <div class="summary-time">{{snoozeTill | date:'shortTime'}}</div>
    <div class="summary-hint">This task will return to your active list at that time.</div>
  </div>

  <div class="option-group">
    <div class="group-header">Quick picks</div>
    <div class="chip-row">
      <button mat-stroked-button
              class="chip"
              *ngFor="let option of quickOptions"
              [color]="active === option.key ? 'primary' : undefined"
              [class.active]="active === option.key"
              (click)="selectChange(option.seconds, option.key)">
        {{option.label}}
      </button>
    </div>
  </div>

  <div class="option-group">
    <div class="group-header">Custom duration</div>
    <div class="select-row">
      <mat-form-field class="snooze-select" [class.active]="active==='days'" appearance="outline">
        <mat-label>Days</mat-label>
        <mat-select (selectionChange)="selectChange($event.value, 'days')">
          <mat-option *ngFor="let day of dayOptions" [value]="day * secondsPerDay">
            {{day}} {{day === 1 ? 'Day' : 'Days'}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="snooze-select" [class.active]="active==='weeks'" appearance="outline">
        <mat-label>Weeks</mat-label>
        <mat-select (selectionChange)="selectChange($event.value, 'weeks')">
          <mat-option *ngFor="let week of weekOptions" [value]="week * secondsPerWeek">
            {{week}} {{week === 1 ? 'Week' : 'Weeks'}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="snooze-select" [class.active]="active==='months'" appearance="outline">
        <mat-label>Months</mat-label>
        <mat-select (selectionChange)="selectChange($event.value, 'months')">
          <mat-option *ngFor="let month of monthOptions" [value]="month * secondsPerMonth">
            {{month}} {{month === 1 ? 'Month' : 'Months'}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-form-field class="reminder-comment" appearance="outline">
    <mat-label>Snooze reminder comment</mat-label>
    <input [(ngModel)]="snoozeComment" matInput>
    <mat-hint>Add a short note so future you knows why this is snoozed.</mat-hint>
  </mat-form-field>
</div>
<div class="actions" mat-dialog-actions>
    <button mat-dialog-close mat-stroked-button>Cancel</button>
    <button (click)="save()" mat-flat-button color="primary">Save snooze</button>
</div>
